// Debug utility to control console output based on environment
const isDebugMode = process.env.REACT_APP_DEBUG_MODE === 'true';

// Create styled console methods for better visibility
const createStyledLogger = (method: 'log' | 'warn' | 'error' | 'info', prefix?: string) => {
  return (...args: any[]) => {
    if (method === 'error' || isDebugMode) {
      const timestamp = new Date().toISOString().split('T')[1].split('.')[0];
      const prefixStr = prefix ? `[${prefix}]` : '';
      console[method](`🕒${timestamp}${prefixStr}`, ...args);
    }
  };
};

export const debug = {
  // Standard debug methods
  log: createStyledLogger('log'),
  warn: createStyledLogger('warn'),  
  error: createStyledLogger('error'), // Always enabled
  info: createStyledLogger('info'),
  
  // Tagged debug methods for better identification in bundles
  client: createStyledLogger('log', 'CLIENT'),
  service: createStyledLogger('log', 'SERVICE'),  
  component: createStyledLogger('log', 'COMPONENT'),
  util: createStyledLogger('log', 'UTIL'),
  processor: createStyledLogger('log', 'PROCESSOR'),
  api: createStyledLogger('log', 'API'),
  
  // Specialized methods
  performance: (...args: any[]) => {
    if (isDebugMode) {
      const timestamp = new Date().toISOString().split('T')[1].split('.')[0];
      console.log(`⏱️${timestamp}[PERF]`, ...args);
    }
  },
  
  trace: (...args: any[]) => {
    if (isDebugMode) {
      const timestamp = new Date().toISOString().split('T')[1].split('.')[0];
      console.trace(`🔍${timestamp}[TRACE]`, ...args);
    }
  },
  
  isEnabled: () => isDebugMode
};